import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.link";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MoreInfo, Item } from './PartnerLink.style';

var PartnerLink = function PartnerLink(_ref) {
  var children = _ref.children,
      link = _ref.link,
      rest = _objectWithoutProperties(_ref, ["children", "link"]);

  var childrenWithProps = React.Children.map(children, function (child) {
    return React.cloneElement(child, _objectSpread({}, rest));
  });
  return React.createElement(Item, {
    href: link,
    type: "standard"
  }, childrenWithProps, React.createElement(MoreInfo, {
    color: "white",
    size: "xxs"
  }, "Find out more"));
};

export default PartnerLink;